<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8">

      <div class="mb-4">
        <h2 class="fw-bold"><i class="bi bi-shield-lock me-2"></i>Your Roles</h2>
        <p class="text-body-secondary">These are the roles assigned to your account. Roles determine what features and actions you can access within Vocabulary.</p>
      </div>

      @if (error) {
        <div class="alert alert-danger" role="alert">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
        </div>
      } @else if (roles.length === 0) {
        <div class="alert alert-warning" role="alert">
          <i class="bi bi-info-circle me-2"></i>No roles assigned to your account.
        </div>
      } @else {
        <div class="card shadow-sm">
          <div class="card-header bg-light">
            <h5 class="mb-0"><i class="bi bi-person-badge me-2"></i>Assigned Roles</h5>
          </div>
          <ul class="list-group list-group-flush">
            @for (role of roles; track role) {
              <li class="list-group-item d-flex align-items-center gap-2">
                <i class="bi bi-check-circle-fill text-success"></i>
                <span class="fw-semibold">{{ role }}</span>
              </li>
            }
          </ul>
        </div>
      }

    </div>
  </div>
</div>
